import React, {useState} from "react";
import {Button, Row, Col, Modal, notification} from "antd";
import NumberInputField from "../../number-input-field";
import Spinner from "../../spinner";
import {distributionCenterService} from "../../../services";
import InputField from "../../input-field";
import '../modals.css'
import i18n from "i18next";


export default function ModalEditDistributionCenter({
                                                      isShow,
                                                      onCloseModal,
                                                      id,
                                                      name,
                                                      delayDelivDispatcher: currentDelayDelivDispatcher,
                                                      delayReserveDeliv: currentDelayReserveDeliv,
                                                      maxCountLoadAuto: currentMaxCountLoadAuto,
                                                      startFillingOrder: currentStartFillingOrder,
                                                      fillingOrder: currentFillingOrder,
                                                      downloadDocument: currentDownloadDocument,
                                                      closingTime: currentClosingTime,
                                                      minOrdersToApprove: currentMinOrdersToApprove,
                                                      minHoursToRefuse: currentMinHoursToRefuse,
                                                      cargoCollectTime: currentCargoCollectTime,
                                                      importantDeliveryMaxTimeLoad: impDeliveryMaxTimeLoad,
                                                      countSkipAvailableTimesNonImportantDelivery: countSkipAvailableTimesNonImpDelivery,
                                                      maxInnerDistance: currentMaxInnerDistance,
                                                    }) {

  const [loadingContentModal, setLoadingContentModal] = useState(false);
  const [fieldsErrors, setFieldsErrors] = useState(null);

  const [delayDelivDispatcher, setDelayDelivDispatcher] = useState(currentDelayDelivDispatcher);
  const [delayReserveDeliv, setDelayReserveDeliv] = useState(currentDelayReserveDeliv);
  const [maxCountLoadAuto, setMaxCountLoadAuto] = useState(currentMaxCountLoadAuto);
  const [startFillingOrder, setStartFillingOrder] = useState(currentStartFillingOrder);
  const [fillingOrder, setFillingOrder] = useState(currentFillingOrder);
  const [downloadDocument, setDownloadDocument] = useState(currentDownloadDocument);
  const [closingTime, setClosingTime] = useState(currentClosingTime);
  const [minOrdersToApprove, setMinOrdersToApprove] = useState(currentMinOrdersToApprove);
  const [minHoursToRefuse, setMinHoursToRefuse] = useState(currentMinHoursToRefuse);
  const [cargoCollectTime, setCargoCollectTime] = useState(currentCargoCollectTime);
  const [maxInnerDistance, setMaxInnerDistance] = useState(currentMaxInnerDistance);
  const [importantDeliveryMaxTimeLoad, setImportantDeliveryMaxTimeLoad] = useState(impDeliveryMaxTimeLoad);
  const [countSkipAvailableTimesNonImportantDelivery, setCountSkipAvailableTimesNonImportantDelivery] = useState(countSkipAvailableTimesNonImpDelivery);

  let bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };

  // сохранение новых данных о РЦ
  const onClickEdit = (e) => {
    e.preventDefault();
    setLoadingContentModal(true);

    distributionCenterService.edit(
        id,
        delayDelivDispatcher,
        delayReserveDeliv,
        maxCountLoadAuto,
        startFillingOrder,
        fillingOrder,
        downloadDocument,
        closingTime,
        minOrdersToApprove,
        minHoursToRefuse,
        cargoCollectTime,
        importantDeliveryMaxTimeLoad,
        countSkipAvailableTimesNonImportantDelivery,
        maxInnerDistance,
    )
        .then((response) => {

          setLoadingContentModal(false);

          if (response.status === "success") {
            notification.success({message: i18n.t('components.notification.titles.distributionCenterServiceCreate'), description: response.message});
            onCloseModal();

          } else if (response.status === "error") {
            setFieldsErrors(response.errors);
          }
        })
        .catch((error) => {
          notification.error({message: i18n.t('components.notification.titles.distributionCenterServiceCreate'), description: error});
          setLoadingContentModal(false);
        });
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
        ? fieldsErrors[nameField][0]
        : null;
  };

  return (
      <Modal
          title={<span>{i18n.t('modals.modalEditDistributionCenter.title', {name: name})}</span>}
          cancelText={i18n.t('main.buttons.close')}
          className="modal-window"
          align={null}
          visible={isShow}
          onCancel={onCloseModal}
          footer={[
            <Button htmlType="submit" key="submit" type="primary" style={bigButtonStyle}
                    onClick={onClickEdit}>{i18n.t('main.buttons.save')}</Button>,
          ]}
      >
        <Spinner loading={loadingContentModal} label={null}>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="delayDelivDispatcher" label={i18n.t('modals.modalEditDistributionCenter.fields.delayDelivDispatcher.title')}
                  value={delayDelivDispatcher} setValue={setDelayDelivDispatcher}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="delayReserveDeliv" label={i18n.t('modals.modalEditDistributionCenter.fields.delayReserveDeliv.title')}
                  value={delayReserveDeliv} setValue={setDelayReserveDeliv}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="maxCountLoadAuto" label={i18n.t('modals.modalEditDistributionCenter.fields.maxCountLoadAuto.title')}
                  value={maxCountLoadAuto} setValue={setMaxCountLoadAuto}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="startFillingOrder" label={i18n.t('modals.modalEditDistributionCenter.fields.startFillingOrder.title')}
                  value={startFillingOrder} setValue={setStartFillingOrder}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="fillingOrder" label={i18n.t('modals.modalEditDistributionCenter.fields.fillingOrder.title')}
                  value={fillingOrder} setValue={setFillingOrder}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="downloadDocument" label={i18n.t('modals.modalEditDistributionCenter.fields.downloadDocument.title')}
                  value={downloadDocument} setValue={setDownloadDocument}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="minOrdersToApprove" label={i18n.t('modals.modalEditDistributionCenter.fields.minOrdersToApprove.title')}
                  value={minOrdersToApprove} setValue={setMinOrdersToApprove}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="minHoursToRefuse" label={i18n.t('modals.modalEditDistributionCenter.fields.minHoursToRefuse.title')}
                  value={minHoursToRefuse} setValue={setMinHoursToRefuse}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <InputField
                  name="closingTime" label={i18n.t('modals.modalEditDistributionCenter.fields.closingTime.title')}
                  value={closingTime} setValue={setClosingTime}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="cargoCollectTime" label={i18n.t('modals.modalEditDistributionCenter.fields.cargoCollectTime.title')}
                  value={cargoCollectTime} setValue={setCargoCollectTime}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <InputField
                  name="ImportantDeliveryMaxTimeLoad" label={i18n.t('modals.modalEditDistributionCenter.fields.importantDeliveryMaxTimeLoad.title')}
                  value={importantDeliveryMaxTimeLoad} setValue={setImportantDeliveryMaxTimeLoad}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="countSkipAvailableTimesNonImportantDelivery" label={i18n.t('modals.modalEditDistributionCenter.fields.countSkipAvailableTimesNonImportantDelivery.title')}
                  value={countSkipAvailableTimesNonImportantDelivery} setValue={setCountSkipAvailableTimesNonImportantDelivery}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <NumberInputField
                  name="maxInnerDistance" label={i18n.t('modals.modalEditDistributionCenter.fields.maxInnerDistance.title')}
                  value={maxInnerDistance} setValue={setMaxInnerDistance}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
          </Row>
        </Spinner>
      </Modal>
  );
}
